export default "__VITE_ASSET__ChDwsihX__"